export default class Warning {
  constructor(componentName, data={}) {
    this.componentName = componentName;
    this.data = data;
  }

  addData(data) {
    this.data = {
      ...this.data,
      ...data
    };
  }
}
